import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
// import {FormArray, FormControl, FormGroup} from '@angular/forms';
// import {ContactSetterService} from '../../../_services/contact-setter.service';
// @ts-ignore
import {
    AssociatedConfig,
    ContactLight,
    ContactModel, ContactService,
    DataTableColumnData,
    GenericOption,
    GenericPayloadModel,
    GenericPayloadType,
    ParentReference,
    PermissionsService
} from '@cas-hub/acabim-common-client';
import {ContactTypeResponse} from '../../../_models/contact-type.model';
// import {ContactOrganisationsService} from '../../../_services/contact-organisations-service';
import {Subscription} from 'rxjs';

export interface FileUsageInput {
    contactID: string;
    fileGUIDS: string[];
}

export interface FileRemovalInput {
    contactID: string;
    fileGUIDS: string[];
}

@Component({
    selector: 'acabim-admin-contact-detail',
    templateUrl: './contact-detail.component.html',
    styleUrls: ['./contact-detail.component.scss']
})
export class ContactDetailComponent implements OnInit {
    @Input() contactID: number | null = null;
    @Input() detailData: ContactLight | undefined;
    @Input() columnData: DataTableColumnData[] | undefined;
    @Input() set loadContact(contactId: number) {
        if(contactId) {
            this.contactID = contactId;
        }
    }
    @Output() updateForm = new EventEmitter<boolean>();
    @Output() updateFile = new EventEmitter<FileUsageInput>();
    @Output() removeFile = new EventEmitter<FileRemovalInput>();

    public mimetypes: string[] = [
        'application/pdf',
        'image/png',
        'image/jpeg'
    ];
    allOrganisations: GenericOption[] = []
    canEdit = false;
    contactOrgSub: Subscription = new Subscription();
    contactType: ContactTypeResponse[] = [];
    contactTypeSelected: any;
    disableProfile = false;
    displayFileGUIDs: string[] = [];
    editForm: any;
    fileGuids: string[] = [];
    fullFiles: { guid: string, name: string, loading: boolean, file: any }[] = [];
    isLoading = false;
    isOrganisation = false;
    organisationProperties: GenericPayloadModel[] = [];
    organisationContacts: GenericPayloadModel[] = [];
    parentRef: ParentReference | null = null;
    profilePropertyTypes: GenericOption[] = [];
    profileProperties: GenericPayloadModel[] = [];
    removeGUIDs: string[] = [];
    selectedContact: ContactModel | undefined;
    showEdit = false;
    defaultFooters: string[] = [
        'Default'
    ];
    componentConfigure: AssociatedConfig = {
        showComment: true,
        showAttachment: true,
        showHistory: true,
        editComment: false,
        editAttachment: true
    }


    constructor(
        private readonly contactService: ContactService,
        // private readonly contactSetter: ContactSetterService,
        // private readonly contactOrganisationsService: ContactOrganisationsService,
        private readonly permissionsService: PermissionsService,
    ) {
    }

    ngOnInit(): void {
        this.isLoading = true;
        this.permissionsService.checkUserPermissions('updateContact').subscribe(p => {
            this.canEdit = p;
        });
        this.permissionsService.checkUserPermissions('addComment').subscribe(p => {
            this.componentConfigure.editComment = p;
        });
        //
        if(this.contactID) {
            this.parentRef = {
                parentRef: this.contactID.toString(),
                parentType: 'contact'
            };
            this.contactService.getContact(this.contactID, true).subscribe(contact => {
                this.isLoading = false;
                this.selectedContact = contact;
                console.dir(this.selectedContact);
                this.profileProperties.push({
                    key:'contactType',
                    label: 'Contact type',
                    value: this.selectedContact.contact_type.name,
                    type: GenericPayloadType.text
                });
                this.profileProperties.push({
                    key:'status',
                    label: 'Status',
                    value: this.selectedContact.status === 1 ? 'Active' : 'Inactive',
                    type: GenericPayloadType.text
                });

                this.profileProperties.push({
                    key:'legal',
                    label: 'Legal representative',
                    value: this.selectedContact.legal_representative === 1 ? 'Yes' : 'No',
                    type: GenericPayloadType.text
                });
                this.isOrganisation = this.selectedContact.is_organisation === 1;
                this.profileProperties.push({
                    key: 'isOrganisation',
                    label: 'Organisation',
                    value: this.selectedContact.is_organisation === 1 ? 'Yes' : 'No',
                    type: GenericPayloadType.text
                });
                // console.dir(this.selectedContact.member_of);
                if (this.selectedContact.member_of) {
                    this.profileProperties.push({
                        key: 'memberOf',
                        label: 'A member of',
                        value: this.selectedContact.member_of.user_name,
                        type: GenericPayloadType.text
                    });
                }
                this.selectedContact.profile_properties.forEach(pp => {
                    if(pp) {
                        const isDefault = pp.default_for_type === 1 && pp.type.indexOf('name') < 0 ? '*' : '';
                        const baseLabel = pp.label.length > 0 ? pp.label : pp.type.charAt(0).toUpperCase() + pp.type.slice(1);
                        const label = pp.subtype ? baseLabel + ' [' + pp.subtype + ']' : baseLabel;
                        const value = pp.value === 'true' || pp.value === 'false' ? (pp.value === 'true' ? 'Yes' : 'No') : pp.value;
                        this.profileProperties.push({
                            key: pp.id.toString(),
                            label: label + isDefault,
                            value: value,
                            type: GenericPayloadType.text
                        });
                    }
                });
                this.selectedContact.organisation_properties.forEach(pp => {
                    if(pp) {
                        const baseLabel = pp.label.length > 0 ? pp.label : pp.type.charAt(0).toUpperCase() + pp.type.slice(1);
                        const label = pp.subtype ? baseLabel + ' [' + pp.subtype + ']' : baseLabel;
                        const value = pp.value === 'true' || pp.value === 'false' ? (pp.value === 'true' ? 'Yes' : 'No') : pp.value;
                        this.organisationProperties.push({
                            key: pp.id.toString(),
                            label: label,
                            value: value,
                            type: GenericPayloadType.text
                        });
                    }
                });
                if(this.selectedContact.contacts) {
                    this.selectedContact.contacts.forEach(pp => {
                        if (pp) {
                            this.organisationContacts.push({
                                key: pp.id.toString(),
                                label: 'Name',
                                value: pp.user_name,
                                type: GenericPayloadType.text
                            });
                        }
                    });
                }
            });
        }
    }


    onCancel() {
        this.updateForm.emit(false);
    }

    onEdit(contactID: number): void {
        this.showEdit = true;
    }

    toggleEditModal(value: any) {
        console.dir(value);
        // this.showEdit = $event;
    }

    submitEdit(result: boolean) {
        if (result) {
            this.showEdit = false;
            this.updateForm.emit(true);
        }
    }

}

